import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'processes/workflows/workflowsModal/CLOSE',
  OPEN_ERROR: 'processes/workflows/workflowsModal/OPEN_ERROR',
  OPEN_REQUEST: 'processes/workflows/workflowsModal/OPEN_REQUEST',
  OPEN_SUCCESS: 'processes/workflows/workflowsModal/OPEN_SUCCESS',
  SAVE_ERROR: 'processes/workflows/workflowsModal/SAVE_ERROR',
  SAVE_REQUEST: 'processes/workflows/workflowsModal/SAVE_REQUEST',
  SAVE_SUCCESS: 'processes/workflows/workflowsModal/SAVE_SUCCESS',
};

export const workflowModal = {
  close: () => ({
    type: types.CLOSE,
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to load workflow',
  ),
  request: ({ callBack, mode, workflowId }) => ({
    type: types.OPEN_REQUEST,
    payload: { callBack, mode, workflowId },
  }),
  success: ({ workflow, workSteps }) => ({
    type: types.OPEN_SUCCESS,
    payload: { workflow, workSteps },
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save workflow',
  ),
  request: ({ workStepIds }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      workStepIds,
    },
  }),
  success: ({ workflow }) => ({
    type: types.SAVE_SUCCESS,
    payload: { workflow },
  }),
};
